import React from "react";
import "./modal.css"

export class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.handleModalClick = this.handleModalClick.bind(this);
        this.handleEsc = this.handleEsc.bind(this);
    }

    handleModalClick(e) {
        if(e.target.className.includes("modal") && e.target.className.includes("fade")) {
            this.props.onClose();
        }
    }

    componentDidMount() {
        this.handleBody(this.props.show);
    }

    componentWillReceiveProps(nextProps) {
        this.handleBody(nextProps.show);
    }

    handleEsc(e) {
        if(e.keyCode === 27) {
            this.props.onClose();
        }
    }

    handleBody(show) {
        let body = document.getElementsByTagName("body");
        let modalOpen;
        if (show) {
            modalOpen = document.createElement("div");
            modalOpen.className="modal-open";
            body[0].appendChild(modalOpen);
        } else {
            modalOpen = document.getElementsByClassName("modal-open");
            if(modalOpen[0]) {
                modalOpen[0].remove();
            }
        }
    }

    render() {
        return (
            <div onKeyDown={this.handleEsc}>
                {this.props.show ? (
                    <div className="modal fade in" tabIndex="-1" role="dialog" aria-labelledby="privacyPolicyModal" onClick={this.handleModalClick}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    {typeof this.props.title === "string" ? <div className="modal-title"
                                                                                 dangerouslySetInnerHTML={{__html: this.props.title}}></div> :
                                        <div className="modal-title">this.props.title</div>}
                                    <button type="close" className="close" aria-label="close"
                                            onClick={this.props.onClose}>x
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {typeof this.props.body === "string" ?
                                        <div dangerouslySetInnerHTML={{__html: this.props.body}}>
                                        </div> :
                                        <div>
                                            {this.props.body}
                                        </div>}
                                </div>
                                <div className="modal-footer">
                                    {typeof this.props.footer === "string" ?
                                        <div dangerouslySetInnerHTML={{__html: this.props.footer}}>
                                        </div> :
                                        <div>
                                            {this.props.footer}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modal/Modal.js